<template>
    <div id="banner" v-if="getActiveAmount > 0" @click="onClick">
        <p>A Forecast is active.<span style="cursor: pointer">click here</span> to learn more</p>
    </div>
</template>
<script>
import { ROUTES } from "@/components/forecasts/router";
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            ROUTES
        };
    },
    computed: {
        ...mapGetters("forecast", { getActiveAmount: "getActiveAmount" })
    },
    methods: {
        ...mapActions("forecast", { setIsShowActiveOnly: "setIsShowActiveOnly" }),
        onClick() {
            this.setIsShowActiveOnly(true);
            if (this.$router.currentRoute.path !== ROUTES.BASE) {
                this.$router.push(`${ROUTES.BASE}`);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/themes";
#banner {
    padding: 5px;
    background-color: $color2 !important;
    cursor: pointer;
    color: white;
    text-align: center;
    letter-spacing: 2px;
    text-shadow: -2px -1px 0px black;
    font-family: Oswald, Sans-Serif;
}
</style>



// WEBPACK FOOTER //
// ForecastBanner.vue?34437800